import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthForm from '../../components/AuthForm/AuthForm';
import './Registration.scss';

class AuthLogin extends Component {
  static propTypes = {
    registration: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    annulError: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    havePassword: PropTypes.bool.isRequired,
    profile: PropTypes
      .shape({})
      .isRequired,
    setUser: PropTypes.func.isRequired,
    externalLogin: PropTypes.func.isRequired,
    linkedinStatus: PropTypes.string.isRequired,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      const {
        email, havePassword, id, profile,
      } = this.props;
      this.props.setUser({
        email, havePassword, id, profile,
      });
      this.props.externalLogin();
    }
  }

  submitHandler = (data) => {
    this
      .props
      .registration(data);
  }

  render() {
    const {
      status, error, annulError, linkedinStatus,
    } = this.props;
    return (<AuthForm
      label="sign up"
      buttonLabel="sign up"
      type="registration"
      annulError={annulError}
      status={status}
      error={error}
      linkedinStatus={linkedinStatus}
      submitHandler={this.submitHandler}
      specifiedValidator={{
      password: true,
    }}
      className="registration-form"
    />);
  }
}

export default AuthLogin;



// WEBPACK FOOTER //
// ./src/containers/Registration/Registration.js